import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.header.public');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrich-header-public',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichHeaderPublicComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public logout() {
        location.href = '/auth/logout';
    }
}

export default PortalNrichHeaderPublicComponent;